<template>
  <div class="account-content">
    <div class="username">
      <v-icon class="user-icon">mdi-account-circle</v-icon>
      <span>{{ username }}</span>
    </div>
    <div class="user-status">{{ userStatus }}</div>
    <div class="disconnect-button-box">
      <v-btn text color="primary" @click="disconnect()">Déconnexion</v-btn>
    </div>
  </div>
</template>

<style scoped>
@import "../assets/styles/global-styles.css";
@import "../assets/styles/variables.css";

.account-content {
  background: white;
  padding: 4px 12px;
  text-align: left;
}
.username {
  font-size: 1em;
  color: var(--dark-text-color);
  margin-bottom: 0px;
  display: flex;
  align-items: center;
}
.user-icon {
  font-size: 24px;
  margin-right: 8px;
  color: var(--dark-text-color) !important;
}
.user-status {
  font-size: 0.9em;
  color: var(--details-text-color);

  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: var(--primary-separator-color);
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.disconnect-button-box {
  color: var(--primary-text-color);
  margin-bottom: 10px;
}
</style>

<script lang="ts">
import { AuthenticationService } from "@/services/authentication.service";
import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * @desc boite affichant les propriétés de l'utilisateur connecté
 */
@Component({
  components: {},
})
export default class UserAccount extends Vue {
  @Prop()
  username?: string;

  @Prop()
  userStatus?: string;

  /**
   * @desc déconnecte l'utilisateur
   */
  private disconnect(): void {
    AuthenticationService.logout(axios).then(() => {
      this.$root.$emit("logout");
      this.$router.push("/connexion").catch((err) => {
        console.log(err);
        return;
      });
    });
  }
}
</script>
